const maintenanceCardLabel = {
  description: 'Descripción',
  value: 'Valor',
  company: 'Empresa',
  sendToMaintenanceDate: 'Fecha de envío prevista para el mantenimiento',
  returnFromMaintenanceDate: 'Fecha prevista de devolución de mantenimiento',
  warranty: 'Plazo de garantía',
  expiration: 'Período de validez',
};

export default maintenanceCardLabel;